import React, { useEffect, useRef, useState, useCallback } from "react";
import styles from "./MediaLibraryModal.module.css";
import { withContentRef } from "../../utils/contentRef";
import { FaPlay, FaPause } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { FaCloudArrowUp } from "react-icons/fa6";
import { RiDeleteBin6Line } from "react-icons/ri";
import Button from "../button/Button";
import Loader from "../../utils/loader/Loader";

import {
  getSectionMediaLibrary,
  mediaDelete,
  UploadImage,
  UploadMovie,
  urlImageUpload,
  urlUpload,
  getAllContent,
} from "../../api/HttpApis";
import { formatDate } from "../../utils/dateFormatter";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import Hls from "hls.js";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useRbac } from "../../rbac/RbacContext";
import { showToast } from "../../utils/Toastify/Toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import InputText from "../inputText/InputText";
import {
  IoSearchOutline,
  IoGridOutline,
  IoListOutline,
  IoCopyOutline,
  IoDownloadOutline,
  IoEyeOutline,
  IoCheckmarkDoneOutline,
} from "react-icons/io5";
import { getMedia } from "../../api/bulk-upload-api";
import usePorgress from "../../hooks/usePorgress";
import { describeItem, barPercent, formatBytes } from "../../upload/uploadManager";

// Debounce hook
const useDebounce = (value, delay) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
};
const CONTENT_TYPES = ["All", "Series", "Movie", "Short Clip", "Podcast", "Live"];

const MediaLibraryModal = ({
  isFloating,
  endpoint,
  type,
  mode: propMode,
  isOpen: controlledIsOpen,
  setIsOpen: controlledSetIsOpen,
  handleVideovalue = () => { },
  handleimagesvalue = () => { },
  unCheckHandleValue = () => { },
  onSelectVideos = () => { },
  onSelectImages = () => { },
  handleUploadImage = () => { },
  showCheckbox = true,
  selectMultipal = false,
  onMultiVideoSelect,
  sectionManager,
  preSelected = [],
}) => {
  const [activeTab, setActiveTab] = useState("video");
  const [videoUrl, setVideoUrl] = useState(null);
  // Multiple files can be picked/dropped at once, for both video and image uploads.
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const search = useDebounce(searchInput.trim(), 1000);
  const [totalCount, setTotalCount] = useState(0);
  
  const [playingVideo, setPlayingVideo] = useState(null);
  const videoRefs = useRef({});
  const fileInputRef = useRef();
  const navigate = useNavigate();
  const { can } = useRbac();
  const [selectedVideos, setSelectedVideos] = useState(null);
  const [trailer, setTrailer] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [image, setImage] = useState(null);
  const [mediaLoading, setMediaLoading] = useState(false);
  // Seeded once from preSelected (the section's current content) so the modal
  // opens showing what's already picked and can stage toggles on top of it --
  // this component fully unmounts/remounts each time it opens, so this only
  // ever runs against the section's real state at open time.
  const [multiVideo, setMultiVideo] = useState(() =>
    Array.isArray(preSelected) ? [...preSelected] : []
  );
  const initialPreSelectedIdsRef = useRef(new Set());
  const [isDragging, setIsDragging] = useState(false);
  const [viewMode, setViewMode] = useState("grid");
  const [sortBy, setSortBy] = useState("recent");
  const [manageMode, setManageMode] = useState(false);
  const [bulkSelected, setBulkSelected] = useState([]);
  const [lightboxItem, setLightboxItem] = useState(null);
  const [lightboxVideoLoading, setLightboxVideoLoading] = useState(false);
  const lightboxVideoRef = useRef(null);
  // Autoplay is attempted once per source -- "canplay" also fires after every
  // seek, and replaying then would resume a video the user had paused.
  const lightboxAutoplayTriedRef = useRef(false);
  // "loading" | "playing" | "error" — so a stream that never starts shows a
  // message instead of a silent black box.
  const [lightboxStatus, setLightboxStatus] = useState("loading");
  const [activeContentType, setActiveContentType] = useState("All");
  const params = useParams();
  const seriesId = params.seriesId || location.state?.seriesId;
  const seasonId = params.seasonId || location.state?.seasonId;
  const nextEpisodeNumber =
    params.nextEpisodeNumber || location.state?.nextEpisodeNumber;
  const pathSegments = location.pathname.split("/");
  const urlEndpoint = pathSegments[pathSegments.length - 1];
  const name = location.state?.name || endpoint || urlEndpoint || "";
  const [tabState, setTabState] = useState({
    video: { media: [], page: 1, hasMore: true },
    image: { media: [], page: 1, hasMore: true },
  });
  // Match both the old protected invite route (/creator-onboarding) and the
  // new public signup route (/creator-signup) — both render CreatorOnboarding
  // and should open the media modal on the Image tab (profile/banner are images),
  // not the default Video tab.
  const isCreatorOnboarding =
    location.pathname.includes("creator-onboarding") ||
    location.pathname.includes("creator-signup");

  const { mode: stateMode, isOpen: stateIsOpen } = location.state || {};

  const mode = propMode || stateMode || "page";
  const [internalIsOpen, setInternalIsOpen] = useState(mode === "page");

  const isControlled =
    controlledIsOpen !== undefined && controlledSetIsOpen !== undefined;

  const isOpen =
    mode === "page"
      ? true
      : isControlled
        ? controlledIsOpen
        : stateIsOpen ?? internalIsOpen;

  const setIsOpen =
    mode === "page"
      ? () => { }
      : isControlled
        ? controlledSetIsOpen
        : setInternalIsOpen;

  useEffect(() => {
    if (isCreatorOnboarding && activeTab === "video") {
      setActiveTab("image");
    }
  }, [isCreatorOnboarding, activeTab]);

  useEffect(() => {
    if (mode === "modal") {
      if (isOpen) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "auto";
      return () => (document.body.style.overflow = "auto");
    }
  }, [isOpen, mode]);

  // Snapshot preSelected IDs when the modal opens so the "already in section"
  // check stays stable across checkbox toggles (parent mutates preSelected on
  // every selection change).
  useEffect(() => {
    if (isOpen) {
      initialPreSelectedIdsRef.current = new Set(
        (Array.isArray(preSelected) ? preSelected : [])
          .map((p) => p?.id)
          .filter((id) => id !== undefined && id !== null)
      );
    }
  }, [isOpen]);

  const [scrollPositions, setScrollPositions] = useState({
    video: 0,
    image: 0,
  });
  const scrollContainerRef = useRef(null);
  const initLoader = async () => {
    setMediaLoading(true);
    await fetchMedia(activeTab, 1, search);
    setMediaLoading(false);
  };
  const fetchMedia = async (tab, pageNum = 1, searchQuery = "", contentType = activeContentType) => {
    try {
      let res = null;
      let list = [];
      let total = 0;
      if (sectionManager) {
        const apiType = contentType === "All" ? "all" : contentType.toLowerCase().replace(" ", "");
        res = await getAllContent(pageNum, apiType, searchQuery);
        // Keyed by content ref (series id negated) to match the builder's
        // selected cards -- movie #4 and series #4 are different items.
        list = (res?.data?.data?.contents || []).map(withContentRef);
        total = res?.data?.data?.total || 0;
        setTotalCount(total);
      }
      else {

        res = await getMedia({
          mediaType: tab,
          page: pageNum,
          search: searchQuery,
        });
        list = res?.data?.data || [];
        total = res?.data?.total || 0;
        setTotalCount(total);
      }


      if (pageNum == 1) {
        setTabState((prev) => {
          const currentTab = prev[tab];
          return {
            ...prev,
            [tab]: {
              media: pageNum === 1 ? list : [...currentTab.media, ...list],
              page: pageNum,
              hasMore: sectionManager
                ? list.length > 0 && list.length < total
                : list.length > 0,
            },
          };
        });
      } else {
        setTabState((prev) => {
          const currentTab = prev[tab];
          const updatedMedia = [...currentTab.media, ...list];
          return {
            ...prev,
            [tab]: {
              media: pageNum === 1 ? list : updatedMedia,
              page: pageNum,
              hasMore: sectionManager
                ? list.length > 0 && updatedMedia.length < total
                : list.length > 0,
            },
          };
        });
      }
    } catch (err) {
      showToast("Error fetching media", "error");
    } finally {
    }
  };
  // The upload manager owns every in-flight transfer (src/upload/uploadManager.js);
  // this only registers the grid refresh and reads the queue for display.
  const { uploadQueue, enqueueUpload, enqueueProcessing } = usePorgress(fetchMedia, activeTab);
  useEffect(() => {
    if (!isOpen) return;
    setTabState((prev) => ({
      ...prev,
      [activeTab]: { ...prev[activeTab], page: 1, hasMore: true },
    }));
    initLoader();
  }, [isOpen, search, activeTab, activeContentType]);

  // Restore scroll position when tab changes
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = scrollPositions[activeTab] || 0;
    }
  }, [activeTab, scrollPositions]);

  // Save scroll position while scrolling
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    setScrollPositions((prev) => ({
      ...prev,
      [activeTab]: scrollTop,
    }));
  };

  // Infinite scroll load more
  const handleEndReached = () => {
    const { page } = tabState[activeTab];
    const nextPage = page + 1;
    fetchMedia(activeTab, nextPage, search);
  };

  // File selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (activeTab === "image") {
      setImage(files[0]);
      setSelectedFiles((prev) => [...prev, ...files]);
    } else if (activeTab === "video") {
      setImage(null);
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };
  useEffect(() => {
    if (type === "image" || type === "video") {
      setActiveTab(type);
    }
  }, [type, isOpen]);

  const handleUpload = useCallback(async () => {
    if (!selectedFiles.length && !url.trim()) {
      return showToast("Please select a file or enter a URL", "error");
    }
    setLoading(true);

    try {
      const formData = new FormData();
      if (activeTab === "image") {
        if (url.trim() !== "" && isValidUrl(url)) {
          formData.append("image_url", url.trim());
          const response = await urlImageUpload(formData);
          showToast(response?.data?.message || "Image uploaded successfully!", "success");
          setSelectedFiles([]);
          setUrl("");
          setImage(null);
        }
        else if (selectedFiles.length) {
          // The backend endpoint (/image-upload) accepts exactly one file per request
          // (multer .single('image')), so each image needs its own FormData and its
          // own request — never append multiple files to one FormData under the same
          // field name. Promise.allSettled so one bad image can't block the rest.
          const results = await Promise.allSettled(
            selectedFiles.map((file) => {
              const imgFormData = new FormData();
              imgFormData.append("image", file);
              return UploadImage(imgFormData);
            })
          );
          const failed = results.filter((r) => r.status === "rejected").length;
          const succeeded = results.length - failed;
          if (succeeded > 0) {
            showToast(
              succeeded === 1
                ? "Image uploaded successfully!"
                : `${succeeded} images uploaded successfully!`,
              "success"
            );
          }
          if (failed > 0) {
            showToast(`${failed} image${failed > 1 ? "s" : ""} failed to upload`, "error");
          }
          setSelectedFiles([]);
          setImage(null);
        }
      } else if (selectedFiles.length) {
        // Hand every file to the upload manager and return immediately. We deliberately
        // do NOT await each transfer serially:
        //  - the manager owns each one, so closing this modal can't kill a 30GB upload;
        //  - the queue cards and grid placeholders appear at once, instead of the
        //    user's selections vanishing for minutes with nothing to show for it;
        //  - one bad file (Promise.allSettled) can't block the rest of the batch.
        const results = await Promise.allSettled(
          selectedFiles.map((file) => enqueueUpload(file, { title: file.name }))
        );
        const failed = results.filter((r) => r.status === "rejected").length;
        const succeeded = results.length - failed;
        if (succeeded > 0) {
          showToast(
            succeeded === 1
              ? `Uploading "${selectedFiles[0].name}" — you can keep working.`
              : `Uploading ${succeeded} files — you can keep working.`,
            "success"
          );
        }
        if (failed > 0) {
          showToast(`${failed} file${failed > 1 ? "s" : ""} failed to start uploading`, "error");
        }
      } else {
        formData.append("video_url", url.trim());
        const response = await urlUpload(formData);
        if (response?.data?.status === "success") {
          const uploaded = response?.data?.data || {};
          // A direct-video URL (mp4, etc.) is fetched into Bunny and must transcode.
          // Follow its progress so the card climbs and flips to "ready" like a file
          // upload, instead of freezing at "Processing 0%". An HLS/m3u8 URL is ready
          // immediately (processing=false), so nothing to track.
          if (uploaded.video_id && uploaded.processing) {
            enqueueProcessing(uploaded.video_id, {
              title: uploaded.title || url.trim(),
            });
          }
          setSelectedFiles([]);
          setUrl("");
          setImage(null);
        }
        showToast("URL uploaded successfully!", "success");
      }

      // Reset state
      setSelectedFiles([]);
      setUrl("");
      setVideoUrl(null);
      setImage(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (err) {
      showToast(err?.response?.data?.message || "Upload failed", "error");
    } finally {
      setLoading(false);
      fetchMedia(activeTab);
    }
  }, [selectedFiles, url, activeTab, image, enqueueUpload, enqueueProcessing]);

  // Play / pause
  const handlePlayPause = useCallback(
    (video, idx) => {
      const videoEl = videoRefs.current[video.id];
      if (!videoEl) return;

      if (playingVideo === video.id) {
        videoEl.pause();
        setPlayingVideo(null);
        return;
      }

      // Pause previously playing video
      if (playingVideo !== null) {
        const prevVideoEl = videoRefs.current[playingVideo];
        prevVideoEl?.pause();
      }

      const startPlayback = () => {
        videoEl.play().catch((err) => console.warn("Play failed:", err));
        setPlayingVideo(video.id);
      };

      if (videoEl.canPlayType("application/vnd.apple.mpegurl")) {
        videoEl.src = video.HLSPlaylistURL;
        startPlayback();
      } else if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(video.HLSPlaylistURL);
        hls.attachMedia(videoEl);
        hls.on(Hls.Events.MANIFEST_PARSED, startPlayback);
      } else {
        videoEl.src = video.HLSPlaylistURL;
        startPlayback();
      }
    },
    [playingVideo]
  );

  // Where the content form for a media item lives, plus the router state it
  // expects. Shared by handleDone (navigate) and the title <Link>.
  // `from=media-library` lets the form recover the media link when it's opened
  // in a new tab, where router state doesn't survive.
  const contentFormTarget = (id, metadata_id = null) => {
    const urlId = metadata_id || id;
    const hasMetadataId = Boolean(metadata_id);
    let path = `/video/${urlId}`;
    const hasSeriesData = seriesId && seasonId && nextEpisodeNumber;

    if (hasSeriesData) {
      path += `/${seriesId}/${seasonId}/${nextEpisodeNumber}`;
    }

    path += hasMetadataId ? `?from=media-library` : `?meta=false&from=media-library`;

    return {
      to: path,
      state: {
        movieId: id,
        metadata_id: metadata_id || "",
        name,
        ...(hasSeriesData && { seriesId, seasonId, nextEpisodeNumber }),
        mediaLibrary: true,
        episode: location?.state?.episode || "",
      },
    };
  };

  const handleDone = useCallback(
    (id, metadata_id = null) => {
      if (id) {
        const { to, state } = contentFormTarget(id, metadata_id);
        navigate(to, { state });
      }
    },
    [navigate, seriesId, seasonId, nextEpisodeNumber, name]
  );

  useEffect(() => {
    if (onSelectVideos || onSelectImages) {
      if (selectedVideos !== null) {
        onSelectVideos(selectedVideos);
        handleUploadImage(selectedImage);
      }
      if (selectedImage !== null) {
        onSelectImages(selectedImage);
        handleUploadImage(selectedImage);
      }
    }
  }, [selectedVideos, onSelectVideos, selectedImage, onSelectImages]);

  const handleCheckboxChange = (item) => {
    if ((type = "trailer")) {
      setTrailer(item);
    }

    if (item.media_type === "video") {
      setSelectedVideos(item);
      handleVideovalue(item);

      // Purely local staging -- toggling a checkbox here must NOT touch the
      // parent (section) until the selection is confirmed via Done. That's
      // what lets Cancel discard everything picked/unpicked this session.
      setMultiVideo((prev = []) =>
        prev.some((v) => v.id === item.id)
          ? prev.filter((v) => v.id !== item.id)
          : [...prev, item]
      );
    } else if (item.media_type === "image") {
      setSelectedImage(item);
      onSelectImages(item);
      handleimagesvalue(item);
    }
  };

  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };
  useEffect(() => {
    if ((url.trim() !== "" && isValidUrl(url)) || selectedFiles.length) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [url, selectedFiles]);

  const currentTabData = tabState[activeTab];
  const handleActiveTab = (tab) => {
    if (tab === "image") {
      setSelectedFiles([]);
      setUrl("");
    } else if (tab === "video") {
      setImage(null);
      setSelectedFiles([]);
      setUrl("");
    }
    setActiveTab(tab);
  };

  // Takes the item, not just its id: the server needs media_type because videos
  // and images can share an id, and without it the delete is refused.
  const handleDelete = async (item) => {
    const id = item?.id ?? item;
    const mediaType = item?.media_type || activeTab;
    const label = mediaType === "image" ? "image" : "video";
    const confirmed = window.confirm(
      `Delete this ${label} permanently?\n\n` +
        `The file is removed from storage and cannot be recovered. ` +
        `If it is used as a profile picture, channel banner or artwork elsewhere, ` +
        `the delete will be refused.`
    );

    if (!confirmed) return;

    try {
      const result = await mediaDelete(id, mediaType);
      // The row is gone but the file was left in storage: a partial success, so
      // it must not read as a clean one.
      const partial = result?.data?.data?.storage_cleanup_failed;
      showToast(
        result?.data?.message || "Media deleted successfully",
        partial ? "warning" : "success"
      );
      fetchMedia(activeTab, 1, search);
    } catch (err) {
      // The server explains refusals precisely - in use as a profile picture,
      // ambiguous id, no longer there - so show its message rather than a
      // generic one, and refresh so the grid matches reality either way.
      showToast(
        err?.response?.data?.message || "Could not delete this item",
        "error"
      );
      fetchMedia(activeTab, 1, search);
    }
  };

  // Standalone Library page (not an embedded picker) — only here do we expose
  // bulk-management UI so the picker's own selection/Done flow is never hijacked.
  const isManageContext = mode === "page" && !sectionManager;

  const getItemUrl = (item) =>
    item?.bunny_cdn_url ||
    item?.HLSPlaylistURL ||
    item?.url ||
    item?.portrait ||
    "";

  /**
   * Live state for a grid item, preferring the in-memory upload queue over the
   * last-fetched row. The queue updates many times a second while the API row only
   * changes when the grid is refetched, so this is what makes a card climb smoothly
   * instead of appearing minutes later frozen at a stale number.
   */
  const liveUpload = (item) =>
    uploadQueue.find((q) => q.videoId === item?.id) || null;

  /**
   * The single state a card renders from: uploading | stalled | processing | ready | failed.
   * Falls back to `upload_state` from the API (added alongside real byte tracking) and,
   * for older responses, to encodeProgress/HLS presence.
   */
  const cardState = (item) => {
    if (item?.media_type === "image") return "ready";
    const live = liveUpload(item);
    if (live) {
      if (live.phase === "paused" || live.phase === "interrupted") return "stalled";
      return live.phase; // uploading | processing | ready | failed
    }
    if (item?.upload_state) return item.upload_state;
    // Legacy fallback for a response without lifecycle fields.
    if (item?.HLSPlaylistURL || Number(item?.encodeProgress) >= 100) return "ready";
    return "processing";
  };

  /** Percent to show on the card for its current state. */
  const cardPercent = (item) => {
    const live = liveUpload(item);
    if (live) return Math.round(barPercent(live));
    const state = cardState(item);
    if (state === "ready") return 100;
    if (state === "uploading" || state === "stalled") return Number(item?.upload_progress) || 0;
    return Number(item?.encodeProgress) || 0;
  };

  /** Short status line under the badge, e.g. "8.1 GB of 30 GB · 14 MB/s · 26 min left". */
  const cardStatusText = (item) => {
    const live = liveUpload(item);
    if (live) return describeItem(live);
    const state = cardState(item);
    if (state === "uploading") return item?.upload_label || "Uploading";
    if (state === "stalled") return item?.upload_error || "Upload interrupted";
    if (state === "failed") return item?.upload_error || "Failed";
    if (state === "processing") {
      const pct = Number(item?.encodeProgress) || 0;
      return pct > 0 ? `Transcoding ${pct}%` : "Queued for transcoding";
    }
    return "";
  };

  const isReady = (item) => cardState(item) === "ready";
  const isProcessing = (item) => item?.media_type !== "image" && !isReady(item);

  /**
   * Whether a card is currently picked. Mirrors the checkbox's own `checked` expression
   * exactly — it is only used to draw a selected state on the card, so that a selection
   * reads at a glance instead of relying on one small checkbox.
   */
  const isItemSelected = (item) => {
    if (item?.media_type === "image") return selectedImage?.id === item?.id;
    return selectMultipal
      ? (multiVideo || []).some((v) => v.id === item?.id)
      : selectedVideos === item;
  };

  /** Runtime as m:ss, shown on the thumbnail. Null when we don't know it yet. */
  const formatRuntime = (seconds) => {
    const s = Number(seconds);
    if (!Number.isFinite(s) || s <= 0) return null;
    const m = Math.floor(s / 60);
    const rem = Math.round(s % 60);
    if (m >= 60) {
      const h = Math.floor(m / 60);
      return `${h}:${String(m % 60).padStart(2, "0")}:${String(rem).padStart(2, "0")}`;
    }
    return `${m}:${String(rem).padStart(2, "0")}`;
  };

  // navigator.clipboard needs a secure context AND clipboard-write permission,
  // which can be blocked inside iframes/embeds. Fall back to a hidden-textarea
  // + execCommand("copy") so it works everywhere.
  const writeClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      throw new Error("clipboard API unavailable");
    } catch {
      try {
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        ta.style.pointerEvents = "none";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        return ok;
      } catch {
        return false;
      }
    }
  };

  const copyUrl = async (item) => {
    const link = getItemUrl(item);
    if (!link) {
      showToast("No URL available for this item", "error");
      return;
    }
    const ok = await writeClipboard(link);
    showToast(
      ok ? "URL copied to clipboard" : "Failed to copy URL",
      ok ? "success" : "error"
    );
  };

  const downloadItem = async (item) => {
    const link = getItemUrl(item);
    if (!link) {
      showToast("No file available to download", "error");
      return;
    }
    try {
      const response = await fetch(link, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = item?.title || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(blobUrl);
    } catch (err) {

      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
      showToast(
        "Direct download failed, opened file in a new tab instead",
        "warning"
      );
    }
  };

  // ---- Bulk management (standalone page only) ---------------------------
  const isBulkSelected = (item) => bulkSelected.some((b) => b.id === item.id);

  const toggleBulk = (item) => {
    setBulkSelected((prev) =>
      prev.some((b) => b.id === item.id)
        ? prev.filter((b) => b.id !== item.id)
        : [...prev, item]
    );
  };

  // Standalone Library page: a video can open its content form only once it has
  // finished encoding (no HLS playlist / thumbnail before that), and only for
  // staff allowed to edit linked content or create content from unlinked media.
  const canOpenForm = (item) =>
    isManageContext &&
    !manageMode &&
    isReady(item) &&
    can("content", item.metadata_id ? "edit" : "create");

  // Click on a card's media area (video thumbnail or image). Manage mode toggles
  // the bulk selection for both videos and images; otherwise a ready video
  // opens its content form (playback lives on the Play button only).
  // Clicks on any control inside the media area keep their own behaviour, so
  // controls added later don't need their own stopPropagation.
  const handleMediaClick = (e, item) => {
    if (e.target.closest("button, input, label, a")) return;
    // A drag that selected text isn't a click to open.
    if (window.getSelection?.()?.toString()) return;
    if (manageMode) {
      toggleBulk(item);
      return;
    }
    if (canOpenForm(item)) handleDone(item.id, item.metadata_id);
  };

  const selectAllVisible = () => {
    const visible = currentTabData?.media || [];
    setBulkSelected(
      bulkSelected.length === visible.length ? [] : [...visible]
    );
  };

  const exitManageMode = () => {
    setManageMode(false);
    setBulkSelected([]);
  };

  const bulkCopy = async () => {
    const links = bulkSelected.map(getItemUrl).filter(Boolean);
    if (!links.length) {
      showToast("No URLs to copy", "error");
      return;
    }
    const ok = await writeClipboard(links.join("\n"));
    showToast(
      ok ? `Copied ${links.length} URL(s)` : "Failed to copy URLs",
      ok ? "success" : "error"
    );
  };

  const bulkDelete = async () => {
    if (!bulkSelected.length) return;
    const confirmed = window.confirm(
      `Delete ${bulkSelected.length} item(s) permanently?\n\n` +
        `The files are removed from storage and cannot be recovered. ` +
        `Items still in use elsewhere will be skipped and reported.`
    );
    if (!confirmed) return;

    // Send each item's own media_type - a bulk selection can mix videos and
    // images, and an id alone is ambiguous across the two tables.
    const targets = bulkSelected.map((b) => ({
      id: b.id,
      mediaType: b.media_type || activeTab,
    }));
    // In batches rather than all at once: each delete also makes a storage call,
    // and "Select all" over a scrolled list can easily be 100+ items. Firing
    // them simultaneously risks timeouts and gives the server no breathing room.
    const BATCH = 5;
    const results = [];
    for (let i = 0; i < targets.length; i += BATCH) {
      const batch = targets.slice(i, i + BATCH);
      const settled = await Promise.allSettled(
        batch.map((t) => mediaDelete(t.id, t.mediaType))
      );
      results.push(...settled);
    }
    // A rejected promise is a refusal (in use elsewhere, not found, ambiguous
    // id). Report the first reason rather than a bare count, so "failed 3" is
    // actionable instead of mysterious.
    const rejected = results.filter((r) => r.status === "rejected");
    const failed = rejected.length;
    const firstReason = rejected[0]?.reason?.response?.data?.message;

    if (failed === targets.length) {
      showToast(firstReason || `Could not delete ${failed} item(s)`, "error");
    } else if (failed) {
      showToast(
        `Deleted ${targets.length - failed}. ${failed} skipped${
          firstReason ? `: ${firstReason}` : " (still in use)"
        }`,
        "warning"
      );
    } else {
      showToast(`Deleted ${targets.length} item(s)`, "success");
    }
    setBulkSelected([]);
    fetchMedia(activeTab, 1, search);
  };

  // Client-side ordering of the currently loaded media. "recent" keeps the
  // server order (newest first); name sorts are purely cosmetic over loaded
  // items and don't affect infinite-scroll fetching.
  const sortMedia = (list = []) => {
    if (sortBy === "name-asc") {
      return [...list].sort((a, b) =>
        (a.title || "").localeCompare(b.title || "")
      );
    }
    if (sortBy === "name-desc") {
      return [...list].sort((a, b) =>
        (b.title || "").localeCompare(a.title || "")
      );
    }
    return list;
  };

  const renderToolbar = () => (
    <div className={styles.toolbar}>
      <p className={styles.videoCount}>
        <strong>{totalCount}</strong>
        {activeTab === "video" ? " videos" : " images"} found
      </p>
      <div className={styles.toolbarRight}>
        {isManageContext && (
          <button
            type="button"
            className={`${styles.manageBtn} ${
              manageMode ? styles.manageBtnActive : ""
            }`}
            onClick={() => (manageMode ? exitManageMode() : setManageMode(true))}
          >
            <IoCheckmarkDoneOutline />
            {manageMode ? "Exit" : "Manage"}
          </button>
        )}
        <select
          className={styles.sortSelect}
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          aria-label="Sort media"
        >
          <option value="recent">Most recent</option>
          <option value="name-asc">Name A–Z</option>
          <option value="name-desc">Name Z–A</option>
        </select>
        <div className={styles.viewToggle} role="group" aria-label="View mode">
          <button
            type="button"
            className={`${styles.viewBtn} ${
              viewMode === "grid" ? styles.viewBtnActive : ""
            }`}
            aria-label="Grid view"
            aria-pressed={viewMode === "grid"}
            onClick={() => setViewMode("grid")}
          >
            <IoGridOutline />
          </button>
          <button
            type="button"
            className={`${styles.viewBtn} ${
              viewMode === "list" ? styles.viewBtnActive : ""
            }`}
            aria-label="List view"
            aria-pressed={viewMode === "list"}
            onClick={() => setViewMode("list")}
          >
            <IoListOutline />
          </button>
        </div>
      </div>
    </div>
  );

  // Load HLS into the lightbox player when previewing a video.
  useEffect(() => {
    if (!lightboxItem || !lightboxItem.HLSPlaylistURL) return;
    const el = lightboxVideoRef.current;
    if (!el) return;
    const src = lightboxItem.HLSPlaylistURL;
    setLightboxVideoLoading(true);
    lightboxAutoplayTriedRef.current = false;
    let hls;
    let cancelled = false;
    let mediaRecoveries = 0;
    setLightboxStatus("loading");

    // Start playback explicitly — the autoPlay attribute alone is unreliable
    // once hls.js attaches asynchronously. If the browser blocks unmuted
    // autoplay, retry muted so the preview still starts.
    const startPlayback = () => {
      if (cancelled) return;
      el.play().catch((err) => {
        if (cancelled || err?.name !== "NotAllowedError") return;
        el.muted = true;
        el.play().catch(() => {});
      });
    };
    const onPlaying = () => !cancelled && setLightboxStatus("playing");
    const onError = () => !cancelled && setLightboxStatus("error");
    el.addEventListener("playing", onPlaying);

    // Prefer hls.js (MSE) where available: it recovers from transient
    // network/media errors that leave a native player stuck on a black frame.
    if (Hls.isSupported()) {
      hls = new Hls();
      hls.on(Hls.Events.MANIFEST_PARSED, startPlayback);
      hls.on(Hls.Events.ERROR, (_evt, data) => {
        if (!data?.fatal || cancelled) return;
        // A fatal stream error never reaches the <video>'s onError, so clear
        // the spinner here too.
        setLightboxVideoLoading(false);
        if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
          hls.startLoad();
        } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR && mediaRecoveries < 2) {
          mediaRecoveries += 1;
          hls.recoverMediaError();
        } else {
          console.warn("Preview playback failed:", data);
          hls.destroy();
          hls = null;
          onError();
        }
      });
      hls.loadSource(src);
      hls.attachMedia(el);
    } else {
      el.addEventListener("loadedmetadata", startPlayback);
      el.addEventListener("error", onError);
      el.src = src;
    }

    return () => {
      cancelled = true;
      el.removeEventListener("playing", onPlaying);
      el.removeEventListener("loadedmetadata", startPlayback);
      el.removeEventListener("error", onError);
      if (hls) hls.destroy();
      el.pause();
      el.removeAttribute("src");
      el.load();
    };
  }, [lightboxItem]);

  // Close the lightbox on Escape.
  useEffect(() => {
    if (!lightboxItem) return;
    const onKey = (e) => {
      if (e.key === "Escape") setLightboxItem(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightboxItem]);

  const renderActions = (item) => (
    <div className={styles.actionGroup}>
      {/* An item still uploading/transcoding has no playable stream yet (the player
          404s or errors), so preview stays off until it's ready. */}
      <button
        type="button"
        className={styles.iconAction}
        // Nothing playable exists until upload + transcoding finish; the
        // button re-enables on its own once the card's state flips to ready.
        title={isProcessing(item) ? "Preview available once processing finishes" : "Preview"}
        aria-label="Preview"
        disabled={isProcessing(item)}
        onClick={() => setLightboxItem(item)}
      >
        <IoEyeOutline />
      </button>
      <button
        type="button"
        className={styles.iconAction}
        title="Copy URL"
        aria-label="Copy URL"
        onClick={() => copyUrl(item)}
      >
        <IoCopyOutline />
      </button>
      <button
        type="button"
        className={styles.iconAction}
        title="Download"
        aria-label="Download"
        onClick={() => downloadItem(item)}
      >
        <IoDownloadOutline />
      </button>
      <button
        type="button"
        className={`${styles.iconAction} ${styles.iconActionDanger}`}
        title="Delete"
        aria-label="Delete"
        onClick={() => handleDelete(item)}
      >
        <RiDeleteBin6Line />
      </button>
    </div>
  );

  // Confirming a selection lives in exactly one handler, shared by the header button
  // and the sticky bar at the bottom of the list. This is also the ONLY point that
  // pushes the multi-select session (staged locally in `multiVideo`) out to the
  // parent -- checkboxes never call onMultiVideoSelect/unCheckHandleValue directly,
  // so picking and un-picking items mid-session has no effect on the section
  // until this fires. Cancelling just closes the modal and drops `multiVideo`.
  const confirmSelection = useCallback(() => {
    const currentItem =
      selectedVideos || selectedImage || (multiVideo.length > 0 ? multiVideo[0] : null);

    if (selectMultipal) {
      const finalIds = new Set(multiVideo.map((v) => v.id));
      const addedItems = multiVideo.filter(
        (v) => !initialPreSelectedIdsRef.current.has(v.id)
      );
      const removedItems = (Array.isArray(preSelected) ? preSelected : []).filter(
        (p) => p?.id !== undefined && p?.id !== null && !finalIds.has(p.id)
      );

      if (addedItems.length && typeof onMultiVideoSelect === "function") {
        onMultiVideoSelect(addedItems);
      }
      removedItems.forEach((item) => unCheckHandleValue(item));
    }

    if (mode === "page" || isFloating) {
      if (currentItem) handleDone(currentItem.id, currentItem.metadata_id);
    } else {
      setIsOpen(false);
    }
    if (mode === "modal") {
      setIsOpen(false);
    }
  }, [
    selectedVideos,
    selectedImage,
    multiVideo,
    selectMultipal,
    preSelected,
    onMultiVideoSelect,
    unCheckHandleValue,
    mode,
    isFloating,
    handleDone,
    setIsOpen,
  ]);

  // Dismissing without confirming (the header close icon, or clicking the overlay
  // backdrop) discards everything picked/unpicked this session -- `multiVideo` is
  // just local state that's thrown away with the rest of the component on close.
  const handleCancel = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  /**
   * How many items are selected, from whichever state is actually authoritative.
   *
   * This MUST key off `selectMultipal` the same way the checkboxes and isItemSelected do.
   * `handleCheckboxChange` appends to `multiVideo` on every click regardless of mode, so in
   * single-select mode (the Content flow) that array silently grows 1→2→3… while the UI
   * correctly shows only the last-clicked item. Reading `multiVideo.length` unconditionally
   * made the bar report "5 items selected" against a single visible tick.
   */
  const selectedItems = activeTab === "image"
    ? (selectedImage ? [selectedImage] : [])
    : selectMultipal
      ? (multiVideo || [])
      : (selectedVideos ? [selectedVideos] : []);

  const selectionCount = selectedItems.length;
  const hasSelection = selectionCount > 0;

  /**
   * Selection control styling: circular (radio-like) when only one item can be picked,
   * square when several can. Purely visual — the element stays an <input type="checkbox">
   * so every existing handler behaves identically. A real <input type="radio"> was
   * rejected on purpose: a radio cannot be un-checked by clicking it again, which would
   * quietly remove the ability to deselect.
   */
  const selectionInputClass = selectMultipal
    ? styles.videoCheckbox
    : `${styles.videoCheckbox} ${styles.radioStyle}`;

  const clearSelection = () => {
    setMultiVideo([]);
    setSelectedVideos(null);
    setSelectedImage(null);
  };

  // The sticky bar at the bottom of the list is the primary confirm (it sits where the
  // selection was made). Showing Done in the header at the same time gave two identical
  // buttons on screen, so the header falls back to plain close whenever the bar is visible.
  const selectionBarVisible = hasSelection && !manageMode;

  const renderDoneButton = () => {
    if (hasSelection && !selectionBarVisible) {
      return <Button onClick={confirmSelection}>Done</Button>;
    }

    if (mode === "modal") {
      return (
        <IoMdClose
          className={styles.closeIcon}
          onClick={handleCancel}
        />
      );
    }
    return null;
  };

  /**
   * Sticky confirm bar pinned to the bottom of the scrolling list.
   *
   * The Done button only existed in the modal header, so after scrolling through a long
   * library to find a video you had to scroll all the way back up to confirm. This keeps
   * the action next to where the selection was actually made.
   */
  const renderSelectionBar = () => {
    if (!hasSelection || manageMode) return null;
    // Name the single pick from the same authoritative list, so the label can't disagree
    // with the count or with the ticked checkbox.
    const label =
      selectionCount === 1
        ? selectedItems[0]?.title || "1 item selected"
        : `${selectionCount} items selected`;

    return (
      <div className={styles.selectionBar}>
        <span className={styles.selectionInfo} title={label}>
          <IoCheckmarkDoneOutline className={styles.selectionIcon} />
          {trimStr(label, 44)}
        </span>
        <div className={styles.selectionActions}>
          <button type="button" className={styles.selectionClear} onClick={clearSelection}>
            Clear
          </button>
          <Button onClick={confirmSelection}>Done</Button>
        </div>
      </div>
    );
  };

  return (
    <>
      {!isControlled && mode === "modal" && (
        <button onClick={() => setIsOpen(true)}>Open Media Library</button>
      )}
      {!sectionManager && isOpen ? (
        <div
          className={mode === "modal" ? styles.overlay : styles.pageWrapper}
          onClick={mode === "modal" ? handleCancel : undefined}
        >
          <div
            className={styles.container}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className={styles.header}>
              <h2 className={styles.mediaText}>Media Library</h2>
              {renderDoneButton()}
            </div>
            <p className={styles.subText}>
              Browse and manage your uploaded videos and images
            </p>

            {/* Upload */}
            <div
              className={`${styles.uploadBox} ${isDragging ? styles.dragActive : ""
                }`}
              onDragOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(true);
              }}
              onDragEnter={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(true);
              }}
              onDragLeave={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(false);
              }}
              onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setIsDragging(false);

                const files = Array.from(e.dataTransfer.files || []);
                if (!files.length) return;

                const first = files[0];
                if (first.type.startsWith("image/")) {
                  const images = files.filter((f) => f.type.startsWith("image/"));
                  const skipped = files.length - images.length;
                  if (skipped > 0) {
                    showToast(`${skipped} unsupported file${skipped > 1 ? "s" : ""} skipped`, "error");
                  }
                  setActiveTab("image");
                  setImage(images[0]);
                  setSelectedFiles((prev) => [...prev, ...images]);
                } else if (first.type.startsWith("video/")) {
                  const videos = files.filter((f) => f.type.startsWith("video/"));
                  const skipped = files.length - videos.length;
                  if (skipped > 0) {
                    showToast(`${skipped} unsupported file${skipped > 1 ? "s" : ""} skipped`, "error");
                  }
                  setActiveTab("video");
                  setImage(null);
                  setSelectedFiles((prev) => [...prev, ...videos]);
                } else {
                  showToast("Unsupported file type", "error");
                }
              }}
            >
              {activeTab === "video" ? (
                <input
                  type="file"
                  multiple
                  accept=" video/mp4,
      video/webm,
      video/ogg,
      video/quicktime,
      video/x-matroska,
      video/x-msvideo"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              ) : (
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              )}

              {/* Left: click-to-browse. Shows the picked file(s) (with size, so a
                  30GB choice is obvious before committing) and a way to undo the pick.
                  Video allows picking/dropping several files at once; each still gets
                  its own queue card once uploaded (see handleUpload). */}
              <button
                onClick={() => fileInputRef.current?.click()}
                className={styles.uploadButton}
                type="button"
              >
                <FaCloudArrowUp className={styles.cloudIcon} />
                <span className={styles.uploadCopy}>
                  {selectedFiles.length === 1 ? (
                    <>
                      <span className={`${styles.uploadText} ${styles.pickedFile}`}>
                        {selectedFiles[0].name}
                      </span>
                      <span className={styles.paraText}>
                        {formatBytes(selectedFiles[0].size)} · click to choose a different file
                      </span>
                    </>
                  ) : selectedFiles.length > 1 ? (
                    <>
                      <span className={`${styles.uploadText} ${styles.pickedFile}`}>
                        {selectedFiles.length} files selected
                      </span>
                      <span className={styles.paraText}>
                        {formatBytes(selectedFiles.reduce((sum, f) => sum + f.size, 0))} total · click to add more
                      </span>
                    </>
                  ) : (
                    <>
                      <span className={styles.uploadText}>
                        {loading ? "Preparing upload…" : "Upload from Computer"}
                      </span>
                      <span className={styles.paraText}>
                        Drag &amp; drop or click to browse (multiple files supported)
                      </span>
                    </>
                  )}
                </span>
              </button>

              {selectedFiles.length > 0 && (
                <button
                  type="button"
                  className={styles.clearPick}
                  title="Clear selected file(s)"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedFiles([]);
                    setVideoUrl(null);
                    setImage(null);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                  }}
                >
                  ✕
                </button>
              )}

              <span className={styles.uploadDivider}>or</span>

              {/* Right: paste a URL and submit, on one line instead of two stacked rows. */}
              <div className={styles.uploadUrlGroup}>
                <InputText
                  className={styles.urlInput}
                  type="text"
                  value={url}
                  placeholder={activeTab === "image" ? "Paste an image URL…" : "Paste a video URL…"}
                  onChange={(e) => setUrl(e.target.value)}
                />
                <div className={styles.uploadBtn}>
                  <Button
                    onClick={handleUpload}
                    loading={loading}
                    disabled={disabled}
                  >
                    Upload
                  </Button>
                </div>
              </div>

              {/* Overlay stays absolutely positioned, so the controls no longer get
                  unmounted mid-drag (which made the box jump). */}
              {isDragging && (
                <div className={styles.dragOverlay}>Drop file here</div>
              )}
            </div>

            {/* Tabs */}
            {!isCreatorOnboarding && (
              <div className={styles.tabs}>
                {["video", "image"]?.map((tab) => (
                  <Button
                    key={tab}
                    className={activeTab === tab ? styles.activeTab : ""}
                    onClick={() => handleActiveTab(tab)}
                  >
                    {tab === "video" ? "Video Library" : "Image Library"}
                  </Button>
                ))}
              </div>
            )}
            <div className={styles.searchBox}>
              <IoSearchOutline className={styles.searchIcon} />
              <InputText
                type="text"
                placeholder="search by media name..."
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </div>
            {renderToolbar()}
            {/* Content */}
            <div
              className={styles.videoConatiner}
              id="scrollableDiv"
              ref={scrollContainerRef}
              onScroll={handleScroll}
              /* Height is owned by CSS flex now (see .videoConatiner). A fixed 600px — or
                 any maxHeight here — would override the flex basis and reintroduce the
                 taller-than-viewport shell that hid the last row behind the action bar. */
            >
              {mediaLoading ? (
                <div className={styles.loaderWrapper}>
                  <Loader />
                </div>
              ) : currentTabData?.media?.length === 0 ? (
                <div className={styles.noDataFound}>
                  <p>No data found</p>
                </div>
              ) : (
                <InfiniteScroll
                  dataLength={currentTabData?.media?.length || 0}
                  next={handleEndReached}
                  hasMore={currentTabData?.hasMore}
                  scrollableTarget="scrollableDiv"
                >
                  <div
                    className={`${styles.videoGrid} ${
                      viewMode === "list" ? styles.listView : ""
                    }`}
                  >
                    {sortMedia(currentTabData?.media)?.map((item, idx) =>
                      activeTab === "video" ? (
                        <div
                          key={item.id}
                          className={`${styles.videoCard} ${
                            isItemSelected(item) ? styles.cardSelected : ""
                          }`}
                        >
                          {/* Standalone page: only the thumbnail (and the title link)
                              opens the content form — not the whole card, so a click that
                              misses the checkbox or an action icon can't navigate away
                              and drop the selection. Keyboard users get the same action
                              via the title link. */}
                          <div
                            className={`${styles.thumbnail} ${
                              (isManageContext && manageMode) || canOpenForm(item)
                                ? styles.thumbnailClickable
                                : ""
                            }`}
                            onClick={isManageContext ? (e) => handleMediaClick(e, item) : undefined}
                          >
                            {/* A video that hasn't finished encoding has no thumbnail, and
                                the old markup rendered a <video> with a null poster and no
                                src — an empty black box that read as "my upload vanished".
                                In-progress items now get an explicit status tile instead. */}
                            {isReady(item) ? (
                              <video
                                ref={(el) => (videoRefs.current[item.id] = el)}
                                className={styles.videoImage}
                                poster={item.thumbnail}
                                preload="metadata"
                                onCanPlay={(e) => e.target.play()}
                                controls={false}
                              />
                            ) : (
                              <div
                                className={`${styles.statusTile} ${
                                  cardState(item) === "failed" || cardState(item) === "stalled"
                                    ? styles.statusTileAlert
                                    : ""
                                }`}
                              >
                                <FaCloudArrowUp className={styles.statusTileIcon} />
                                <span className={styles.statusTileName}>
                                  {trimStr(item.title || "Untitled", 24)}
                                </span>
                                <div className={styles.statusTileBar}>
                                  <div
                                    className={styles.statusTileFill}
                                    style={{ width: `${cardPercent(item)}%` }}
                                  />
                                </div>
                                <span className={styles.statusTileText}>
                                  {cardStatusText(item)}
                                </span>
                              </div>
                            )}
                            {manageMode && isManageContext && (
                              <label
                                className={styles.bulkCheck}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  checked={isBulkSelected(item)}
                                  onChange={() => toggleBulk(item)}
                                />
                              </label>
                            )}
                            {isProcessing(item) && (
                              <span
                                className={`${styles.processingBadge} ${
                                  cardState(item) === "uploading" ? styles.badgeUploading : ""
                                } ${
                                  cardState(item) === "failed" || cardState(item) === "stalled"
                                    ? styles.badgeAlert
                                    : ""
                                }`}
                              >
                                {cardState(item) === "uploading"
                                  ? `Uploading ${cardPercent(item)}%`
                                  : cardState(item) === "stalled"
                                  ? "Interrupted"
                                  : cardState(item) === "failed"
                                  ? "Failed"
                                  : `Processing ${cardPercent(item)}%`}
                              </span>
                            )}
                            {/* Runtime, so a clip can be told from a feature without opening it. */}
                            {isReady(item) && formatRuntime(item.length) && (
                              <span className={styles.durationBadge}>
                                {formatRuntime(item.length)}
                              </span>
                            )}
                            {/* Standalone page: the overlay is click-through (the thumbnail
                                opens the content form) and only the round button plays.
                                Pickers: the whole overlay still plays/pauses, as before. */}
                            {isReady(item) ? (
                              <div
                                className={`${styles.playButtonOverlay} ${
                                  isManageContext ? styles.overlayPassthrough : ""
                                }`}
                                onClick={
                                  isManageContext ? undefined : () => handlePlayPause(item, idx)
                                }
                              >
                                <button
                                  type="button"
                                  className={styles.playButton}
                                  aria-label={playingVideo === item?.id ? "Pause" : "Play"}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePlayPause(item, idx);
                                  }}
                                >
                                  {playingVideo === item?.id ? (
                                    <FaPause className={styles.playIcon} />
                                  ) : (
                                    <FaPlay className={styles.playIcon} />
                                  )}
                                </button>
                              </div>
                            ) : null}
                          </div>
                          <div className={styles.videoInfo}>
                            {/* On the standalone page the title is a real link to the same
                                content form the thumbnail opens, so Ctrl/Cmd-click,
                                middle-click and "Open in new tab" work. */}
                            {(() => {
                              const openable = canOpenForm(item);
                              const TitleTag = openable ? Link : "div";
                              return (
                                <TitleTag
                                  {...(openable && contentFormTarget(item.id, item.metadata_id))}
                                  className={`${styles.videoTitle} ${
                                    openable ? styles.videoTitleLink : ""
                                  }`}
                                  title={item.title || "Untitled"}
                                >
                                  {trimStr(item.title, 20) || "Untitled"}
                                </TitleTag>
                              );
                            })()}
                            <div className={styles.actions}>
                              <div className={styles.selectSlot}>
                                {showCheckbox && !manageMode ? (
                                  <input
                                    type="checkbox"
                                    className={selectionInputClass}
                                    checked={
                                      selectMultipal
                                        ? multiVideo?.some(
                                          (v) => v.id === item.id,
                                        )
                                        : selectedVideos === item
                                    }
                                    onChange={() => handleCheckboxChange(item)}
                                  />
                                ) : null}
                              </div>
                              {renderActions(item)}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          key={item.id}
                          className={`${styles.imageCard} ${
                            isItemSelected(item) ? styles.cardSelected : ""
                          }`}
                        >
                          {/* Manage mode: clicking the image toggles its bulk selection,
                              the same as a video thumbnail. */}
                          <div
                            className={`${styles.imageWrapper} ${
                              isManageContext && manageMode ? styles.thumbnailClickable : ""
                            }`}
                            onClick={
                              isManageContext && manageMode
                                ? (e) => handleMediaClick(e, item)
                                : undefined
                            }
                          >
                            <img
                              src={item.bunny_cdn_url}
                              alt={item.alt_text || "Media"}
                              className={styles.image}
                            />
                            {manageMode && isManageContext && (
                              <label
                                className={styles.bulkCheck}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  checked={isBulkSelected(item)}
                                  onChange={() => toggleBulk(item)}
                                />
                              </label>
                            )}
                          </div>
                          <div className={styles.imageCheckbox}>
                            <div className={styles.selectSlot}>
                              {showCheckbox && !manageMode ? (
                                <input
                                  type="checkbox"
                                  className={selectionInputClass}
                                  checked={selectedImage?.id === item?.id}
                                  onChange={() => handleCheckboxChange(item)}
                                />
                              ) : null}
                            </div>
                            {renderActions(item)}
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                </InfiniteScroll>
              )}
            </div>
            {renderSelectionBar()}
            {manageMode && isManageContext && (
              <div className={styles.bulkBar}>
                <span className={styles.bulkCount}>
                  {bulkSelected.length} selected
                </span>
                <div className={styles.bulkActions}>
                  <button
                    type="button"
                    className={styles.bulkBtn}
                    onClick={selectAllVisible}
                  >
                    {bulkSelected.length ===
                      (currentTabData?.media?.length || 0) &&
                    bulkSelected.length > 0
                      ? "Deselect all"
                      : "Select all"}
                  </button>
                  <button
                    type="button"
                    className={styles.bulkBtn}
                    onClick={bulkCopy}
                    disabled={!bulkSelected.length}
                  >
                    <IoCopyOutline /> Copy URLs
                  </button>
                  <button
                    type="button"
                    className={`${styles.bulkBtn} ${styles.bulkBtnDanger}`}
                    onClick={bulkDelete}
                    disabled={!bulkSelected.length}
                  >
                    <RiDeleteBin6Line /> Delete
                  </button>
                  <button
                    type="button"
                    className={styles.bulkBtn}
                    onClick={() => setBulkSelected([])}
                    disabled={!bulkSelected.length}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : sectionManager && isOpen ? (
        <div
          className={mode === "modal" ? styles.overlay : styles.pageWrapper}
          onClick={mode === "modal" ? handleCancel : undefined}
        >
          <div
            className={styles.container}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.header}>
              <h2 className={styles.mediaText}>Media Library</h2>
              {renderDoneButton()}
            </div>
            <p className={styles.subText}>
              Browse and manage your uploaded videos and images
            </p>
            <div className={styles.searchBox}>
              <IoSearchOutline className={styles.searchIcon} />
              <InputText
                type="text"
                placeholder="search by media name..."
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </div>

            {/* Content Type Filter Buttons — sectionManager only */}
            <div className={styles.filterRow}>
              {CONTENT_TYPES.map((contentType) => (
                <Button
                  key={contentType}
                  className={`${styles.filterButton} ${activeContentType === contentType ? styles.activeTab : ""}`}
                  onClick={() => setActiveContentType(contentType)}
                >
                  {contentType}
                </Button>
              ))}
            </div>

            {renderToolbar()}
            <div
              className={styles.videoConatiner}
              id="scrollableDiv"
              ref={scrollContainerRef}
              onScroll={handleScroll}
              /* Height is owned by CSS flex now (see .videoConatiner). A fixed 600px — or
                 any maxHeight here — would override the flex basis and reintroduce the
                 taller-than-viewport shell that hid the last row behind the action bar. */
            >
              {mediaLoading ? (
                <div className={styles.loaderWrapper}>
                  <Loader />
                </div>
              ) : currentTabData?.media?.length === 0 ? (
                <div className={styles.noDataFound}>
                  <p>No data found</p>
                </div>
              ) : (
                <InfiniteScroll
                  dataLength={currentTabData?.media?.length || 0}
                  next={handleEndReached}
                  hasMore={currentTabData?.hasMore}
                  scrollableTarget="scrollableDiv"
                >
                  <div
                    className={`${styles.videoGrid} ${
                      viewMode === "list" ? styles.listView : ""
                    }`}
                  >
                    {sortMedia(currentTabData?.media)?.map((item, idx) =>
                      activeTab === "video" ? (
                        <div
                          key={item.id}
                          className={`${styles.videoCard} ${
                            isItemSelected(item) ? styles.cardSelected : ""
                          }`}
                        >
                          <div className={styles.thumbnail}>
                            <img
                              src={item.portrait}
                              alt={item.title || "Media"}
                              className={styles.videoImage}
                            />
                          </div>
                          <div className={styles.videoInfo}>
                            <div className={styles.videoTitleSection}>
                              {/* ✅ UPDATED: title attribute shows full title on hover */}
                              <div
                                className={styles.videoTitle}
                                title={item.title || "Untitled"}
                              >
                                {trimStr(item.title, 20) || "Untitled"}
                              </div>
                              <div className={styles.videoDate}>
                                {trimStr(item?.library_type)}
                              </div>
                            </div>
                            <div>
                              <div className={styles.actions}>
                                <input
                                  type="checkbox"
                                  className={selectionInputClass}
                                  checked={
                                    selectMultipal
                                      ? multiVideo?.some((v) => v.id === item.id)
                                      : selectedVideos === item
                                  }
                                  onChange={() => handleCheckboxChange(item)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null,
                    )}
                  </div>
                </InfiniteScroll>
              )}
            </div>
            {renderSelectionBar()}
          </div>
        </div>
      ) : null}

      {/* Lightbox preview */}
      {lightboxItem && (
        <div
          className={styles.lightboxOverlay}
          onClick={() => setLightboxItem(null)}
        >
          <button
            type="button"
            className={styles.lightboxClose}
            aria-label="Close preview"
            onClick={() => setLightboxItem(null)}
          >
            <IoMdClose />
          </button>
          <div
            className={styles.lightboxContent}
            onClick={(e) => e.stopPropagation()}
          >
            {lightboxItem.HLSPlaylistURL ? (
              <div className={styles.lightboxVideoWrap}>
                <video
                  ref={lightboxVideoRef}
                  className={`${styles.lightboxMedia} ${styles.lightboxVideo}`}
                  controls
                  autoPlay
                  playsInline
                  onPlaying={() => setLightboxVideoLoading(false)}
                  onWaiting={() => setLightboxVideoLoading(true)}
                  onError={() => setLightboxVideoLoading(false)}
                  // If the browser blocks autoplay, "playing" never fires — drop the
                  // loader so the user can press play themselves.
                  onCanPlay={(e) => {
                    if (lightboxAutoplayTriedRef.current) return;
                    lightboxAutoplayTriedRef.current = true;
                    e.currentTarget
                      .play()
                      ?.catch(() => setLightboxVideoLoading(false));
                  }}
                />
                {lightboxVideoLoading && (
                  <Loader className={styles.lightboxLoader} />
                )}
              </div>
            ) : (
              <img
                src={getItemUrl(lightboxItem)}
                alt={lightboxItem.alt_text || lightboxItem.title || "Preview"}
                className={styles.lightboxMedia}
              />
            )}
            {lightboxItem.HLSPlaylistURL && lightboxStatus !== "playing" && (
              <div className={styles.lightboxStatus}>
                {lightboxStatus === "error"
                  ? "This video can't be played right now. It may still be processing."
                  : "Loading video…"}
              </div>
            )}
            {lightboxItem.title && (
              <div className={styles.lightboxTitle}>{lightboxItem.title}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MediaLibraryModal;